import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IClient } from './Client.service';

interface QueryCarrier extends Query {
	idClient?: number;
}

export interface ICarrier {
	id?: number;
	name: string;
	isActive: boolean;
	client?: Partial<IClient>;
	createdAt?: Date;
	updatedAt?: Date;
	actions?: any;
}

abstract class CarrierService {
	static async getAll(
		params?: QueryCarrier
	): Promise<PaginationContent<ICarrier> | undefined> {
		let isActive;
		if (params?.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<ICarrier> = await request(
				'/carriers',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		data: ICarrier,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'post');
	}

	static async edit(
		data: ICarrier,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'patch');
	}

	private static async createOrEdit(
		content: ICarrier,
		setError: React.Dispatch<React.SetStateAction<string>>,
		mode: 'post' | 'patch'
	) {
		try {
			const { id, client, createdAt, updatedAt, ...data } = content;
			const url = mode === 'post' ? '/carriers' : `/carriers/${id}`;
			const response = await request(url, mode, {
				data: { ...data, idClient: client?.id },
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}
}

export default CarrierService;
